import Core from "../core";
import { AxiosError, AxiosResponse } from "axios";

async function getTrainingData(company_id: number, user_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/listTrainingsforTrainer?companyId=${company_id}&userId=${user_id}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getMyTrainingData(company_id: number, emp_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/listTrainingforEmployee?companyId=${company_id}&emp_id=${emp_id}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function updateTrainingStatus(status: any, id: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v1/UpdateStatus?&status=${status}&id=${id}`);

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function createMarkasComplete(datas: any) {
  const api = Core.getInstance().api();
  const data = await api.post(`/v1/CreateTrainingEvalutaion`, datas);

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getMarkasCompletedTraining(training_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/listforUpdate?training_id=${training_id}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function updateMarkasComplete(datas: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v1/UpdateTrainingEvalutaion`, datas);

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function exportAll(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/export?company_id=${payload.company_id}&event=${payload.event}&user=${
      payload.user_id
    }&emp_id=${payload.emp_id}&period_id=${payload.period_id}&template_id=${
      payload.template_id
    }&payroll_cycle_id=${payload.payroll_cycle_id}&training_id=${
      payload.training_id
    }&locale=${localStorage.getItem("applang")}&app=2`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
export const trainingServices = {
  getTrainingData,
  updateTrainingStatus,
  getMyTrainingData,
  createMarkasComplete,
  getMarkasCompletedTraining,
  updateMarkasComplete,
  exportAll,
};
